import type { FormListProps } from "antd/lib/form/FormList";
import type { TemplateTestDetails } from "./useTemplateTestDetails";
import type { SelectedTest } from "./types";

export const TESTS_REQUIRED_MESSAGE = "Please add at least one test to the template.";
export const TEST_DETAILS_LOADING_MESSAGE = "Test details are still loading. Please wait for them to finish.";
export const NO_NORMS_AVAILABLE_MESSAGE =
  "One or more tests have no norms. Please add norms to those tests and come back, or remove them from the template.";
export const NORM_REQUIRED_MESSAGE = "Please select a norm for every test.";

export function buildTestListValidationRules(testDetails: TemplateTestDetails): FormListProps["rules"] {
  return [
    {
      validator: async (_, tests: SelectedTest[] = []) => {
        if (tests.length === 0) throw new Error(TESTS_REQUIRED_MESSAGE);
      },
    },
    {
      validator: async (_, tests: SelectedTest[] = []) => {
        if (tests.some((test) => testDetails.loadingIds.has(test.testId))) {
          throw new Error(TEST_DETAILS_LOADING_MESSAGE);
        }
      },
    },
    {
      validator: async (_, tests: SelectedTest[] = []) => {
        const hasTestWithNoNorms = tests.some((test) => {
          const entry = testDetails.details[test.testId];
          return entry !== undefined && entry.norms.length === 0;
        });
        if (hasTestWithNoNorms) throw new Error(NO_NORMS_AVAILABLE_MESSAGE);
      },
    },
    {
      validator: async (_, tests: SelectedTest[] = []) => {
        const hasUnselectedNorm = tests.some((test) => {
          const entry = testDetails.details[test.testId];
          return entry !== undefined && entry.norms.length > 0 && !test.normId;
        });
        if (hasUnselectedNorm) throw new Error(NORM_REQUIRED_MESSAGE);
      },
    },
  ];
}
